import { ContentWrapper, DataTable } from "@components/index";
import { Button, Modal, Pagination, Space, Spin, TableColumnsType, Typography } from "antd";
import { useEffect, useState } from "react";
import { get, remove } from "@services/api.service";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { Icon } from "@iconify/react";
import styles from "../Contract.module.scss";
import { useQuery } from "~/Hooks/useQuery";
import { debounce } from "lodash";
import { useAuth } from "@hooks/useAuth";
import { UserType } from "~/Utils";
import { getFormattedDate, getKey } from "@utils/CommonUtils";
import { FilterDropDown } from "~/Components/FilterDropDown/FilterDropDown";

export const Divisions = () => {
  const [data, setData] = useState<any>([]);
  const { hasPermissions, hasRole } = useHasAccess();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const { openToast, openNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [page, setpage] = useState<number>(0);
  const [orderByName, setOrderByName] = useState("createdOn");
  const navigate = useNavigate();
  const { mask } = useMaskId();
  const { user } = useAuth();
  const [searchString, setSearchString] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const query = useQuery();
  const [apiUrl, setApiUrl] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [appliedCountModal, setAppliedCountModal] = useState(false);
  const [divisionId, setDivisionId] = useState<any>("");
  const [pageStart, setPageStart] = useState<number>(parseInt(query.get("page") || "0") || 0);
  const subsidiary =searchParams.get("subsidiary")||''
  useEffect(() => {
    if (hasRole(["*"])) {
      if (query.get("page")) {
        navigate(`/divisions?page=${pageStart}`, {
          replace: true,
        });
      }
    }
  }, [pageStart]);


  const menuClick = (key: string, record: { [key in string]: any }) => {
    if (key === "delete" && record?.appliedCount != 0) {
      setAppliedCountModal(true);
    } else if (key === "delete") {
      setOpen(true);
      setDivisionId(record?.uniqueId);
    }
    if (key === "edit") {
      navigate(`/divisions/edit/?divisionId=${record.uniqueId}`);
    }
  };

  const handleDelete = () => {
    setIsLoading(true);
    remove(`v1/division/delete-default-division?divisionId=${divisionId}`)
      .then((res: any) => {
        getRecords(sortOrder, orderByName, searchString, pageStart);
        setIsLoading(false);
        openNotification({
          title: "Success",
          message: res.message,
          type: "success",
        });
        setOpen(false);
      })
      .catch((err: any) => {
        setIsLoading(false);
        openNotification({
          title: err,
          message: err.message,
          type: "error",
        });
        setOpen(false);
      });
  };
  const tableActions = {
    callback: menuClick,
    items: [
      {
        label: (
          <Typography.Text
            type="secondary"
            style={{ color: styles.primary }}
          >
            <Space>
              <Icon
                icon="akar-icons:edit"
                inline
                fontSize={16}
                style={{ color: styles.primary }}
              />
              Edit
            </Space>
          </Typography.Text>
        ),
        key: "edit",
      },
      {
        label: (
          <Typography.Text type="danger">
            <Space>
              <Icon
                icon="fluent:delete-48-regular"
                inline
                fontSize={16}
              />
              Delete
            </Space>
          </Typography.Text>
        ),
        key: "delete",
      },
    ],
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
  }, 1000);

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    const url = `v1/division/get-division-list?size=${recordsPerPage}&page=${currentPage}&order=${sortOrder}&orderBy=${orderByParam}&searchText=${encodeURIComponent(
      searchString
    )}&subsidiary=${subsidiary}`;
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData.records && responseData.records.length > 0) {
            setTotalRecords(responseData.totalCount || 0);
            setData(responseData.records);
          } else {
            console.error("No records found in the response");
            setData([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        openToast({
          content: "Getting Divisions failed",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
  }, [searchString, subsidiary]);

  const columns: TableColumnsType = [
    {
      title: "Subsidiary/Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "No. of Admins",
      dataIndex: "adminCount",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    // {
    //   title: "User Email Id",
    //   dataIndex: "userEmail",
    //   render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    // },
    {
      title: "Created Date",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Modified Date",
      dataIndex: "updatedOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Updated By",
      dataIndex: "updatedBy",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchString, pageStart);
  };

  return (
    <ContentWrapper
      title={"Cost Centre"}
      actionItems={
        <Button
          type="primary"
          onClick={() => navigate(`/divisions/create`)}
        >
          <Space>
            <Icon
              icon="akar-icons:plus"
              inline
            />
            Add
          </Space>
        </Button>
      }
    >
      {isLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      <DataTable
        columns={columns?.map((column) => ({
          ...column,
          onHeaderCell: (column: any) => ({
            onClick: () => {
              if (column.sorter) {
                handleTableSort(column, sortOrder, page ? page : 0);
              }
            },
          }),
        }))}
        className="table-clickable"
        tableData={
          data
            ? data?.map((d: any, index: number) => {
                return {
                  ...d,
                  key: getKey(page, index),
                };
              })
            : null
        }
        // {...{
        //   tableActions: tableActions,
        // }}
        tableActions={tableActions}
        isLoading={false}
        exportFileName="Cost Centre"
        onClick={(record) => {
          if(record){
            navigate(`/divisions?page=${pageStart}`)
            navigate(`/divisions/view/?divisionId=${record.uniqueId}&view=${true}`);
          }
        }}
        onSearchChange={handleSearchChange}
        isServerSearchApi={true}
        inputDisable={isLoading}
        isPagination={true}
        totalRecords={totalRecords}
        additionalCTA={
          <FilterDropDown
            viewSubsidiary={false}
            viewStatus={false}
            viewBudget = {true}
            viewPaper
            setStatus={undefined}
            setpage={setPageStart}
          />
        }
        ctaColSpan={17}
        exportApiUrl={apiUrl}
        recordsPerPage={recordsPerPage}
        hideExport={false}
        searchPlaceholderText={"Search Cost Centre"}
        tabOffset={60}
      />

      <div className="pagination">
        <Pagination
          defaultCurrent={pageStart}
          total={data && totalRecords}
          current={pageStart + 1}
          onChange={(page) => {
            const startIndex = page - 1;
            setpage(page - 1);
            setPageStart(startIndex);
            getRecords(sortOrder, orderByName, searchString, startIndex);
          }}
          showSizeChanger={false}
        />
      </div>
      <Modal
        open={open}
        title={"Delete Cost Centre"}
        centered
        closable={false}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        okText={"Delete"}
        onOk={handleDelete}
        okButtonProps={{
          loading: isLoading,
        }}
      >
        <Typography.Text>Are you sure you want to delete this Cost Centre?</Typography.Text>
      </Modal>
      <Modal
        open={appliedCountModal}
        title={"Delete Cost Centre"}
        centered
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setAppliedCountModal(false)}
          >
            Ok
          </Button>,
        ]}
      >
        <Typography.Text>
          This cost centre has already been used to create an SPA, so it cannot be deleted.
        </Typography.Text>
      </Modal>
    </ContentWrapper>
  );
};
